import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import { T } from "../routes/Translate";

// Vencimiento opcional del cupón, por fecha y/o por cantidad de usos (lo que
// ocurra primero). Se guarda en la oferta como cuponExpiresAt ("AAAA-MM-DD",
// vence al terminar ese día) y cuponMaxUses; los usos se cuentan en cuponUses
// al copiar el cupón (ver CopyToClipboardButton).
const CouponExpiryFields = ({ value = {}, onChange }) => {
  const { expiresAt = "", maxUses = "" } = value;
  const set = (patch) => onChange({ ...value, ...patch });
  const today = new Date().toISOString().slice(0, 10);

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary">
        <T>Vencimiento del cupón (opcional): por fecha, por cantidad de usos o ambos</T>
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <TextField
          margin="dense"
          id="cuponExpiresAt"
          label={<T>Vence el</T>}
          type="date"
          fullWidth
          value={expiresAt}
          onChange={(e) => set({ expiresAt: e.target.value })}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: today }}
        />
        <TextField
          margin="dense"
          id="cuponMaxUses"
          label={<T>Cantidad de usos</T>}
          type="text"
          fullWidth
          value={maxUses}
          onChange={(e) => {
            const v = e.target.value;
            if (/^\d*$/.test(v)) set({ maxUses: v });
          }}
          inputProps={{ inputMode: "numeric" }}
        />
      </Box>
    </Box>
  );
};

// Convierte el estado del formulario a los campos que se guardan en Firestore.
export const couponExpiryToDoc = ({ expiresAt = "", maxUses = "" } = {}) => ({
  cuponExpiresAt: expiresAt || null,
  cuponMaxUses: maxUses ? Number(maxUses) : null,
});

// Estado del cupón según fecha y usos: "active" | "expired" | "exhausted".
export const getCouponStatus = ({ cuponExpiresAt, cuponMaxUses, cuponUses } = {}) => {
  if (cuponExpiresAt && new Date(`${cuponExpiresAt}T23:59:59`) < new Date()) return "expired";
  if (cuponMaxUses && (cuponUses || 0) >= cuponMaxUses) return "exhausted";
  return "active";
};

export default CouponExpiryFields;
